module.exports = __webpack_public_path__ + "static/media/400096_02.981e3b73.png";